<ion-tab-button
  class="flex flex-col m-auto justify-center items-center w-full mx-2 shrink-0 truncate"
  [routerLink]="'/home'"
  [routerLinkActive]="'active-tab'"
>
  <home-icon
    color="var(--ui-accent)"
    [width]="'25'"
    [height]="'25'"
    class="my-[2px]"
  />
  Inicio
</ion-tab-button>

<ion-tab-button
  class="flex flex-col m-auto justify-center items-center w-full mx-2 shrink-0 truncate"
  [routerLink]="'/records'"
  [routerLinkActive]="'active-tab'"
>
  <ion-icon name="business-outline" color="accent" />
  Registros
</ion-tab-button>

<ion-tab-button
  class="flex flex-col m-auto justify-center items-center w-full mx-2 shrink-0 truncate"
  [routerLink]="'/notifications'"
  [routerLinkActive]="'active-tab'"
  (click)="resetBadge()"
>
  <notification-badge [notificationNumber]="notificationNumber" />
  <ion-icon name="notifications-outline" />

  Notificaciones
</ion-tab-button>

<ion-tab-button
  class="flex flex-col m-auto justify-center items-center w-full mx-2 shrink-0 truncate"
  [routerLink]="'/profile'"
  [routerLinkActive]="'active-tab'"
>
  <!-- <ion-icon name="business-outline" color="accent" /> -->
  <user-icon
    color="var(--ui-accent)"
    [width]="'25'"
    [height]="'25'"
    class="my-[2px]"
  />
  Perfil
</ion-tab-button>
